import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DisableAllCurrencyForAccountEvent } from '../../model/DisableAllCurrencyForAccountEvent';
import { EnableAllCurrencyForAccountEvent } from '../../model/EnableAllCurrencyForAccountEvent';
import { Pos } from '../../model/Pos';

@Injectable({
  providedIn: 'root',
})
export class PositionService {
  // header
  pullAllPositionEvent: EventEmitter<void> = new EventEmitter<void>();
  pauseCounterEvent: EventEmitter<void> = new EventEmitter<void>();
  restartCounterEvent: EventEmitter<void> = new EventEmitter<void>();
  startCountdownEvent: EventEmitter<void> = new EventEmitter<void>();
  //

  selectTabEvent: EventEmitter<string> = new EventEmitter<string>();

  allAccountStateChangeEvent: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  disableAllCcyForAccountEvent: EventEmitter<DisableAllCurrencyForAccountEvent> =
    new EventEmitter<DisableAllCurrencyForAccountEvent>();
  enableAllCcyForAccountEvent: EventEmitter<EnableAllCurrencyForAccountEvent> =
    new EventEmitter<EnableAllCurrencyForAccountEvent>();

  constructor(private httpClient: HttpClient) {}

  getPositions(): Observable<any> {
    return this.httpClient.get('/bfx/api/abos');
  }

  getWallet(currencies: Array<string>): Observable<any> {
    return this.httpClient.post('/bfx/api/wallet/all', { currencies });
  }

  addFunds(data): Observable<any> {
    return this.httpClient.post('/bfx/api/funds/push', data);
  }

  pull(
    clientAccountId,
    currencies,
    bitfinexAccountId: number,
  ): Observable<any> {
    return this.httpClient.post('/bfx/api/wallet/pull', {
      clientAccountId,
      currencies,
      bitfinexAccountId,
    });
  }

  pullSwapPositions(): Observable<Array<Pos>> {
    return this.httpClient.post<Array<Pos>>(
      '/bfx/api/wallet/pull-swap-positions',
      {},
    );
  }

  pullSwapPosition(accountId: number): Observable<Pos> {
    return this.httpClient.post<Pos>('/bfx/api/wallet/pull-swap-position', {
      accountId,
    });
  }

  pushSwapPositions(command): Observable<any> {
    return this.httpClient.post('/bfx/api/funds/push-swap', command);
  }

  removeFunds(data): Observable<any> {
    return this.httpClient.post('/bfx/api/funds/remove', data);
  }

  pushData(data): Observable<any> {
    return this.httpClient.post('/bfx/api/funds/add', data);
  }

  sweep(): Observable<any> {
    return this.httpClient.post('/bfx/api/wallet/sweep', {});
  }
}
